<template>
  <div>
    <FieldLabel v-if="showFieldHelp" :label="item.name" :help="fieldHelp" :input-id="fieldInputId" :field-id="item.id" :modal-key="modalKey" />
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      :min-width="0"
      max-width="calc(100vw - 16px)"
      content-class="date-time-picker-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-if="prop.show"
          v-model="translateResult"
          :id="fieldInputId"
          :label="showFieldHelp ? undefined : item.name"
          :aria-label="item.name"
          readonly
          dense
          v-bind="attrs"
          v-on="on"
          :rules="prop.modelRules"
          :outlined="prop.outlined"
          :filled="prop.filled"
          :solo="prop.solo"
          :hint="prop.description"
          :persistent-hint="prop.persistenthint"
          :disabled="prop.disabled"
          :class="prop.class"
          :clearable="prop.clearable"
          :color="prop.coloronselect"
          @click:clear.stop="clearValue"
          :prepend-icon="(prop.iconlr === 'prepend' && prop.iconinout === 'out') ? prop.iconmdi : ''"
          :prepend-inner-icon="(prop.iconlr === 'prepend' && prop.iconinout !== 'out') ? prop.iconmdi : ''"
          :append-icon="(prop.iconlr === 'append' && prop.iconinout !== 'out') ? prop.iconmdi : ''"
          :append-outer-icon="(prop.iconlr === 'append' && prop.iconinout === 'out') ? prop.iconmdi : ''"
        />
      </template>

      <v-card width="320" max-width="calc(100vw - 16px)">
        <v-card-text class="px-2 pb-1">
          <v-date-picker
            v-model="modelDate"
            locale="fr"
            no-title
            scrollable
            width="290"
            style="max-width: 100%;"
          />

          <v-row dense align="center" class="mt-2">
            <v-col>
              <v-text-field
                v-model="modelTime"
                type="time"
                label="Heure"
                dense
                outlined
                hide-details
                step="60"
                :disabled="!modelDate"
                @keydown.enter.prevent="validateDraft"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn text small color="primary" @click="selectToday">
                Aujourd'hui
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn text small color="error" @click="clearValue">
            Effacer
          </v-btn>
          <v-spacer />
          <v-btn text small @click="cancel">
            Annuler
          </v-btn>
          <v-btn text small color="primary" @click="validateDraft">
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'

export default {
  name: 'dateTimePicker',

  mixins: [mixinFields, mixinConditionsFields],

  data() {
    return {
      translateResult: '',
      menu: false,
      modelTime: '00:00',
      modelDate: null,
      committedValue: null,
      closingFromAction: false
    }
  },

  watch: {
    menu(val) {
      if (val) {
        this.loadDraft(this.committedValue)
        return
      }

      // Une fermeture par clic hors du menu équivaut à une annulation.
      if (!this.closingFromAction) {
        this.loadDraft(this.committedValue)
        this.updateDisplay(this.committedValue)
      }
      this.closingFromAction = false
    },

    valField(val) {
      this.syncFromValue(val)
    }
  },

  methods: {
    isEmptyDate(value) {
      if (value === null || typeof value === 'undefined') return true
      if (typeof value !== 'string') return false

      const normalized = value.trim()
      return normalized === '' || normalized === '0000-00-00' || normalized === '0000-00-00 00:00:00'
    },

    parsedDate(value) {
      if (this.isEmptyDate(value)) return null
      const parsed = this.moment(value)
      return parsed.isValid() ? parsed : null
    },

    updateDisplay(value) {
      const parsed = this.parsedDate(value)
      this.translateResult = parsed
        ? parsed.format('DD/MM/YYYY HH:mm')
        : (this.prop.placeholder || 'Choisir une date')
    },

    loadDraft(value) {
      const parsed = this.parsedDate(value)
      this.modelDate = parsed ? parsed.format('YYYY-MM-DD') : null
      this.modelTime = parsed ? parsed.format('HH:mm') : '00:00'
    },

    syncFromValue(value) {
      const parsed = this.parsedDate(value)
      this.committedValue = parsed ? parsed.format('YYYY-MM-DD HH:mm:00') : null
      this.updateDisplay(this.committedValue)

      if (!this.menu) this.loadDraft(this.committedValue)
    },

    selectToday() {
      this.modelDate = this.moment().format('YYYY-MM-DD')
    },

    clearDraft() {
      this.modelDate = null
      this.modelTime = '00:00'
    },

    clearValue() {
      this.clearDraft()
      this.committedValue = null
      this.model = null
      this.updateDisplay(null)
      this.change(this.item, null)
      this.changeStoreOnField({ item: this.item, model: null, page: this.modalKey })
      this.closingFromAction = true
      this.menu = false
    },

    cancel() {
      this.loadDraft(this.committedValue)
      this.updateDisplay(this.committedValue)
      this.closingFromAction = true
      this.menu = false
    },

    validateDraft() {
      let value = null

      if (this.modelDate) {
        const time = /^([01]\d|2[0-3]):[0-5]\d$/.test(this.modelTime || '')
          ? this.modelTime
          : '00:00'
        const parsed = this.moment(`${this.modelDate} ${time}`, 'YYYY-MM-DD HH:mm', true)
        if (parsed.isValid()) value = parsed.format('YYYY-MM-DD HH:mm:00')
      }

      this.committedValue = value
      this.model = value
      this.updateDisplay(value)
      this.change(this.item, value)
      this.changeStoreOnField({ item: this.item, model: value, page: this.modalKey })
      this.closingFromAction = true
      this.menu = false
    }
  },

  mounted() {
    this.syncFromValue(this.valField)
  }
}
</script>

<style>
.date-time-picker-menu.v-menu__content {
  width: 320px !important;
  min-width: 0 !important;
  max-width: calc(100vw - 16px) !important;
}
</style>
